import { Link } from "react-router-dom";
import './footer.css';

const Footer = () => {
  return (
    <footer className="gpt3__footer">
      {/* Top CTA */}
      <div className="gpt3__footer-cta">
        <h2>Ready to step into the future of learning?</h2>
        <Link to="/contact">
          <button type="button">Request Early Access</button>
        </Link>
      </div>

      <div className="gpt3__footer-divider" />

      {/* Links Grid */}
      <div className="gpt3__footer-links">
        {/* Brand */}
        <div className="gpt3__footer-links_logo">
          <span className="gpt3__footer-brand">EduConnect</span>
          <p>Quality home tutoring for Noida, Ghaziabad &amp; Delhi. Empowering students since 2020.</p>
        </div>

        {/* Links */}
        <div className="gpt3__footer-links_div">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#wgpt3">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Company */}
        <div className="gpt3__footer-links_div">
          <h4>Company</h4>
          <ul>
            <li><a href="#home">Terms &amp; Conditions</a></li>
            <li><a href="#home">Privacy Policy</a></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Get in touch */}
        <div className="gpt3__footer-links_div">
          <h4>Get in Touch</h4>
          <ul>
            <li><a href="mailto:themindfitnesshub@gmail.com">themindfitnesshub@gmail.com</a></li>
            <li><a href="tel:+919315427607">+91 9315427607</a></li>
            <li><a href="https://wa.me/9315427607" target="_blank" rel="noopener noreferrer">WhatsApp Us</a></li>
          </ul>
        </div>
      </div>

      <div className="gpt3__footer-divider" />

      {/* Copyright */}
      <div className="gpt3__footer-copyright">
        <p>&copy; {new Date().getFullYear()} Themindfitnesshub. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
